import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2, ReceiptText, XCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Audit history of orders placed through the app (all brokers). Hidden when empty. */
export default function BrokerOrders() {
  const { authHeaders } = useAuth();
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    axios.get(`${API}/brokers/orders`, { headers: authHeaders() })
      .then((r) => setOrders(r.data.orders))
      .catch(() => setOrders([]));
  }, [authHeaders]);

  if (!orders?.length) return null;

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="mt-8" data-testid="broker-orders-section">
      <div className="flex items-center gap-2 mb-4">
        <ReceiptText className="w-5 h-5 text-[#00FFA3]" />
        <h2 className="text-lg font-bold text-white" style={{ fontFamily: "Unbounded" }}>BROKER ORDERS</h2>
        <span className="text-xs text-gray-500">{orders.length} placed via TradeInsights</span>
      </div>
      <Card className="glass-effect">
        <CardContent className="p-4 space-y-2">
          {orders.map((o, i) => {
            const buy = o.order?.side === "buy";
            return (
              <div
                key={o.review_id || i}
                className="flex items-center justify-between gap-3 rounded-lg border border-white/5 bg-white/[0.02] px-3 py-2.5"
                data-testid={`broker-order-${i}`}
              >
                <div className="flex items-center gap-3 min-w-0">
                  <span className={`px-2 py-0.5 rounded text-[10px] font-bold shrink-0 ${buy ? "bg-[#00FFA3]/15 text-[#00FFA3]" : "bg-[#FF3B30]/15 text-[#FF3B30]"}`}>
                    {(o.order?.side || "").toUpperCase()}
                  </span>
                  <div className="min-w-0">
                    <div className="text-sm font-bold text-white mono">
                      {o.order?.quantity} × {o.order?.symbol}
                      <span className="text-gray-500 font-normal text-xs ml-2">{o.order?.order_type}</span>
                    </div>
                    <div className="text-[10px] text-gray-600">
                      {o.broker} · {new Date(o.created_at).toLocaleString()}
                    </div>
                  </div>
                </div>
                <div className={`flex items-center gap-1 text-xs font-semibold shrink-0 ${o.placed !== false ? "text-[#00FFA3]" : "text-[#FF3B30]"}`}>
                  {o.placed !== false ? <CheckCircle2 className="w-3.5 h-3.5" /> : <XCircle className="w-3.5 h-3.5" />}
                  {o.placed !== false ? "Sent" : "Rejected"}
                </div>
              </div>
            );
          })}
        </CardContent>
      </Card>
    </motion.div>
  );
}
